import { GeneratePermission } from "./generatePermission"

export type PermissionGroup<T> = { PERMISION: string } & T

export const generatePermissionGroup = <T extends Record<string, GeneratePermission>>(permissions: T): PermissionGroup<T> => {
  const values = Object.values(permissions)

  if (values.length === 0) {
    throw new Error("Permission group tidak boleh kosong")
  }

  const module = values[0].MODULE

  // validasi agar semua child module sama
  const isValid = values.every(p => p.MODULE === module)
  if (!isValid) {
    throw new Error("Semua permission dalam satu group harus memiliki MODULE yang sama")
  }

  return {
    PERMISION: module,
    ...permissions,
  }
}
